var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaneTakeoff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 22H22M6.36 17.4L4 17L2 13L3.1 12.45C3.37916 12.3093 3.6874 12.2361 4 12.2361C4.3126 12.2361 4.62084 12.3093 4.9 12.45L5.07 12.55C5.34916 12.6907 5.6574 12.7639 5.97 12.7639C6.2826 12.7639 6.59084 12.6907 6.87 12.55L8 12L5 6L5.9 5.55C6.23267 5.38635 6.60429 5.31838 6.97335 5.3537C7.34242 5.38902 7.6944 5.52622 7.99 5.75L12.01 8.75C12.3066 8.97572 12.6604 9.11404 13.0315 9.14938C13.4025 9.18472 13.7761 9.11567 14.11 8.95L18.3 6.89C18.8354 6.62009 19.4523 6.55948 20.03 6.72L21 7C21.2004 7.05566 21.3859 7.15527 21.543 7.29161C21.7001 7.42794 21.8248 7.59756 21.9082 7.78814C21.9915 7.97873 22.0313 8.18548 22.0247 8.39338C22.0181 8.60128 21.9652 8.80509 21.87 8.99L21.49 9.75C21.26 10.21 20.89 10.59 20.42 10.83L7.58 17.2C7.20245 17.387 6.77547 17.45 6.36 17.38V17.4Z",
    stroke: "#1A1E18",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneTakeoff);
export default __webpack_public_path__ + "static/media/plane-takeoff.c2824b2e392b0ae8e1f345a52ee8e868.svg";
export { ForwardRef as ReactComponent };